export const GET_CVS = 'GET_CVS'

export const GET_CV = 'GET_CV'

export const GET_RATE = 'GET_RATE'

export const GET_SORT_ARY = 'GET_SORT_ARY'

export const CHANGE_PAGE_INDEX = 'CHANGE_PAGE_INDEX'

export const GET_PROFILES = 'GET_PROFILES'

export const GET_OTHERS = 'GET_OTHERS'

export const SET_CV_PAGES = 'SET_CV_PAGES'

export const SET_CV_HEIGHT = 'SET_CV_HEIGHT'

export const SET_PAGE_HEIGHT = 'SET_PAGE_HEIGHT'